import server from "../../../server";
import { useContext, useEffect, useState } from "react";
import EmployeeAttendancePieChart from "./employee-attendance-pie-chart";
import {IEmployeeAttendanceSummary, IMonthlyAttendance} from "./types/employee-attendance-card.types";
import StatsChart from "../../common/stats-chart/stats-chart";
import {firstLetterUpperCase} from "../../../utility/utility";
import {PieChart as PieIcon} from "lucide-react";
import {useNavigate} from 'react-router-dom';
import UserLoginContext from "../../../context/userLoginContext";


const EmployeeAttendanceAnalysis = () => {
    const {user}=useContext(UserLoginContext);
    const currentYear = new Date().getFullYear();
    const [attendanceData, setAttendanceData] = useState<IMonthlyAttendance | null>(null);
    const [loading, setLoading] = useState(true);
    const navigate=useNavigate();

    const handleOnClick = () => {
        navigate('/my/attendance')
    }


    async function fetchSelfAttendance() {
            setLoading(true);
            try {
                const selfAttendance: IEmployeeAttendanceSummary =
                    await server.attendance.employee.getAttendanceSummary(user.employeeId!, currentYear);

                const currentMonth = new Date().toLocaleString("default", {month: "long"}).toUpperCase();

                const currentMonthData = selfAttendance.months.find((month) => month.month === currentMonth);
                setAttendanceData(currentMonthData || null);

            } catch (e) {
                console.log("Error while fetching self attendance", e);
            } finally {
                setLoading(false);
            }
    }

    useEffect(() => {
        fetchSelfAttendance();
    }, []);

    const month = firstLetterUpperCase(attendanceData?.month)
    return (
        <StatsChart
            icon={PieIcon}
            title={"My Attendance Analysis"}
            badge={{text: attendanceData?.month ? `Month: ${month}` : "", color: 'green'}}
            onClick={handleOnClick}
            subtitle={'This month\'s attendance overview.'}
            className={'dashboard-employee-attendance-card'}
        >
            <EmployeeAttendancePieChart attendanceData={attendanceData} loading={loading}/>
        </StatsChart>
    );
};

export default EmployeeAttendanceAnalysis;
